import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const ReprintTagsManufacturingOrders = lazy(() => import('../../../../pages/ReprintTagsManufacturingOrders/ReprintTagsManufacturingOrders'));

export const Route = createFileRoute('/$lang/_authenticated/reprint-tags-manufacturing-orders')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ReprintTagsManufacturingOrders />
    </Suspense>
  ),
});
